export default __webpack_public_path__ + "0ba69282640d4da91eb4fb49865f8a2d.png";